// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.announce {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  height: 40px;
  background: linear-gradient(90deg, var(--teal-dark), var(--teal), var(--amber));
  background-size: 220% 100%;
  animation: announceShift 10s ease infinite;
}

@keyframes announceShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.announce__inner {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  position: relative;
}

.announce__track {
  position: relative;
  height: 18px;
  flex: 1;
  max-width: 720px;
  overflow: hidden;
  text-align: center;
}

.announce__msg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: #fff;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.5s ease, transform 0.5s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8px;
}

.announce__msg--active {
  opacity: 1;
  transform: translateY(0);
}

.announce__link {
  flex-shrink: 0;
  font-size: 11.5px;
  font-weight: 700;
  color: #fff;
  padding: 4px 12px;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  white-space: nowrap;
}

@media (max-width: 720px) {
  .announce__link {
    display: none;
  }

  .announce__msg {
    font-size: 11.5px;
  }

  .announce__inner {
    padding: 0 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AnnounceBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,+EAA+E;EAC/E,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;EAClD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".announce {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1001;\n  height: 40px;\n  background: linear-gradient(90deg, var(--teal-dark), var(--teal), var(--amber));\n  background-size: 220% 100%;\n  animation: announceShift 10s ease infinite;\n}\n\n@keyframes announceShift {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.announce__inner {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  position: relative;\n}\n\n.announce__track {\n  position: relative;\n  height: 18px;\n  flex: 1;\n  max-width: 720px;\n  overflow: hidden;\n  text-align: center;\n}\n\n.announce__msg {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #fff;\n  opacity: 0;\n  transform: translateY(10px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 8px;\n}\n\n.announce__msg--active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.announce__link {\n  flex-shrink: 0;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #fff;\n  padding: 4px 12px;\n  border-radius: 100px;\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  white-space: nowrap;\n}\n\n@media (max-width: 720px) {\n  .announce__link {\n    display: none;\n  }\n\n  .announce__msg {\n    font-size: 11.5px;\n  }\n\n  .announce__inner {\n    padding: 0 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
